export default [{
  path: '/activity',
  name: 'activity',
  component: () => import('@/views/activity/index'),
}]
